import { EntitySupplier } from "../../entity/EntitySupplier";

export class DtoSuppliersPutRes extends EntitySupplier {}
